export default {
  add: 'Producten aan winkelwagen toevoegen',
  addRensa: 'Producten aan Rensa winkelwagen toevoegen',
  error: 'Er is een fout opgetreden, probeer later opnieuw of neem contact op.',
};



// WEBPACK FOOTER //
// ./js/lang/nl/shopping-cart.js